import Quill from 'quill'
import Embed from 'quill/blots/embed'

export interface MentionData {
  name: string
  type: string
}

class MentionBlot extends Embed {
  static blotName = 'mention'
  static tagName = 'span'
  static className = 'mention-blot'

  static create(value: MentionData) {
    // super.create, NOT Embed.create: a direct call on the imported base class
    // resolves Parchment's `this.tagName` against the abstract Embed (which has
    // none) and throws "[Parchment] Blot definition missing tagName" — the
    // exception died inside the popover click handler, so selecting a mention
    // silently did nothing.
    // biome-ignore lint/complexity/noThisInStatic: biome's auto-fix rewrites super.create back to Embed.create, reintroducing that exact crash
    const node = super.create(value) as HTMLSpanElement
    node.setAttribute('data-node-name', value.name)
    node.setAttribute('data-node-type', value.type || '')
    node.setAttribute('contenteditable', 'false')
    node.setAttribute(
      'class',
      'mention-blot py-0.5 px-1.5 bg-[hsl(var(--link)/0.1)] text-link rounded-sm inline-flex items-center gap-1 relative top-0.5',
    )

    const textContainer = document.createElement('span')
    textContainer.textContent = `@${value.name}`

    node.appendChild(textContainer)

    return node
  }

  /** Delta serialization: getContents() must yield {mention: {name, type}} —
   *  getPlainText reads op.insert.mention.name to render "@Name". */
  static value(node: HTMLElement): MentionData {
    return {
      name: node.getAttribute('data-node-name') || '',
      type: node.getAttribute('data-node-type') || '',
    }
  }

  static formats(node: HTMLElement): MentionData {
    return {
      name: node.getAttribute('data-node-name') || '',
      type: node.getAttribute('data-node-type') || '',
    }
  }
}

Quill.register('formats/mention', MentionBlot)

export { MentionBlot }
